import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useStore } from "@/store";
import { NConfigProvider, darkTheme, lightTheme, } from "naive-ui";
import { setANICursor, setANICursorWithGroupElement } from "@/ani-cursor";
import { computed, onMounted, ref, watchEffect, } from "vue";
import { generate } from "@ant-design/colors";
import tools from "@/utils/tools";
import { onBeforeRouteLeave } from "vue-router";
var startDarkThemeTime = 22, endDarkThemeTime = 7;
// const autoSwitchDarkTheme = (targetIsDark: boolean) => {
//   if (store.isDarkTheme !== targetIsDark) {// 没看异或符号怎么使用，先这样
//     store.switchDarkTheme();
//   }
// };
// 切换是否自动调节主题模式时的触发器
var leaveTipWords = "真的要去其他地方吗？似乎还有东西没有加载好（指右上角的小圈圈）";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup: function (__props) {
        var _a;
        var store = useStore();
        var naiveUITheme = computed(function () {
            return store.isDarkTheme ? darkTheme : lightTheme;
        });
        window.naiveUITheme = naiveUITheme;
        var themeColor = ref(window.localStorage.getItem("theme-color") ||
            getComputedStyle(document.documentElement)
                .getPropertyValue("--theme-color-default")
                .trim()), lightThemeColor = ref(generate(themeColor.value)[4]), lightThemeColor2 = ref(generate(themeColor.value)[2]), fontColor = ref(getComputedStyle(document.documentElement).getPropertyValue("--font-color")), pageBg = ref(getComputedStyle(document.documentElement).getPropertyValue("--page-bg")), fontColorReverse = ref(getComputedStyle(document.documentElement).getPropertyValue("--font-color-reverse")), cardBg = ref(getComputedStyle(document.documentElement).getPropertyValue("--card-bg")), mainBorderColor = ref(getComputedStyle(document.documentElement).getPropertyValue("--main-border-color"));
        var updateRefs = function () {
            themeColor.value = getComputedStyle(document.documentElement).getPropertyValue("--theme-color");
            lightThemeColor.value = generate(themeColor.value)[4];
            lightThemeColor2.value = generate(themeColor.value)[2];
            fontColor.value = getComputedStyle(document.documentElement).getPropertyValue("--font-color");
            pageBg.value = getComputedStyle(document.documentElement).getPropertyValue("--page-bg");
            fontColorReverse.value = getComputedStyle(document.documentElement).getPropertyValue("--font-color-reverse");
            cardBg.value = getComputedStyle(document.documentElement).getPropertyValue("--card-bg");
            mainBorderColor.value = getComputedStyle(document.documentElement).getPropertyValue("--main-border-color");
        };
        //   // 在组件卸载时断开观察器 // 根本不会卸载）
        //   onBeforeUnmount(() => {
        //     observer.disconnect();
        //   });
        window.themeColor = themeColor;
        watchEffect(function () {
            document.documentElement.style.setProperty("--theme-color", themeColor.value);
            document.documentElement.style.setProperty("--light-theme-color", lightThemeColor.value);
            document.documentElement.style.setProperty("--light-theme-color-2", lightThemeColor2.value);
        });
        window.setThemeColor = function (color) {
            var s = new Option().style;
            s.color = color;
            // 检查是否为有效颜色
            if (s.color !== "") {
                localStorage.setItem("theme-color", themeColor.value);
                themeColor.value = color;
            }
            else
                console.error("Invalid color: ", color);
        };
        /**
         * @type import('naive-ui').GlobalThemeOverrides
         */
        var themeOverrides = computed(function () {
            return {
                common: {
                    primaryColor: themeColor.value,
                    primaryColorHover: lightThemeColor.value,
                    borderColor: mainBorderColor.value,
                    textColorBase: fontColor.value,
                    cardColor: cardBg.value,
                    bodyColor: pageBg.value,
                    popoverColor: cardBg.value,
                    modalColor: cardBg.value,
                },
                Button: {
                    borderRadiusLarge: "5px",
                    borderRadiusMedium: "4px",
                    borderRadiusSmall: "3px",
                },
                Slider: {
                    fillColor: themeColor.value,
                    fillColorHover: lightThemeColor.value,
                },
                ColorPicker: {
                    textColor: fontColor.value,
                },
            };
        });
        window.themeOverrides = themeOverrides;
        var currentDatetime = new Date();
        var autoSwitchDarkThemeTrigger = function () {
            var startDarkThemeSwitch = function () {
                if (store.isDarkTheme) {
                    store.switchDarkTheme();
                }
            }, endDarkThemeSwitch = function () {
                if (!store.isDarkTheme) {
                    store.switchDarkTheme();
                }
            };
            if (store.isAutoSwitchDarkTheme) {
                tools.addOnTimeExecute(startDarkThemeSwitch, "".concat(startDarkThemeTime, ":00"));
                tools.addOnTimeExecute(endDarkThemeSwitch, "".concat(endDarkThemeTime, ":00"));
            }
            else {
                tools.removeOnTimeExecute(startDarkThemeSwitch);
                tools.removeOnTimeExecute(endDarkThemeSwitch);
            }
        };
        autoSwitchDarkThemeTrigger();
        store.$subscribe(function (mutation, state) {
            // 这里可以添加任何其他逻辑，例如将状态持久化到 localStorage
            if (mutation.type === "switchAutoSwitchDarkTheme") {
                autoSwitchDarkThemeTrigger();
            }
        });
        // 根据系统主题自动切换暗色主题
        var setThemeWithSystemTheme = function () {
            if (window.matchMedia) {
                var isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
                // 跟随系统主题强制自动调整
                if (store.isDarkTheme !== isDark) {
                    store.switchDarkTheme();
                }
            }
        };
        // 监听主题变化
        var themeQuery = window.matchMedia("(prefers-color-scheme: dark)");
        themeQuery.addEventListener("change", function (e) {
            setThemeWithSystemTheme();
        });
        setThemeWithSystemTheme();
        window.live2dStatus = "unmounted"; // 初始化 live2d 状态
        window.resourceBaseUrl = "/";
        setANICursor("body", "/ani/Normal.ani");
        setANICursor(".nprogress-busy", "/ani/Work.ani");
        setANICursor(".loader-wrapper", "/ani/Work.ani");
        var textAbleGroup = ["input", 'input[type="text"]', "textarea", ".cm-content"];
        setANICursorWithGroupElement(textAbleGroup, "/ani/TextSelect.ani");
        var poiterAbleGroup = [
            "a",
            "button",
            ".n-button",
            ".n-select",
            ".n-menu-item-content",
            ".n-dropdown-menu",
            ".n-dropdown-option-body",
            ".md-editor-toolbar-item",
            ".button-box",
            ".n-base-select-option",
            ".n-base-selection-label",
            ".n-base-selection-tags",
            ".md-editor-menu",
            ".md-editor-menu-item",
            ".switch-component-container label",
            ".n-color-picker-trigger",
            ".v-overflow",
        ];
        setANICursorWithGroupElement(poiterAbleGroup, "/ani/AlternateSelect.ani");
        // 设置 md 图片鼠标样式，显示后样式
        var mdImgAbleGroup = [
            ".md-editor-preview img",
            ".md-editor-preview .medium-zoom-image",
        ];
        setANICursorWithGroupElement(mdImgAbleGroup, "/ani/PostIMGMagnifier.ani");
        var mdImgAbleGroup2 = [".medium-zoom-overlay", ".medium-zoom-image--opened"];
        setANICursorWithGroupElement(mdImgAbleGroup2, "/ani/PostIMGMagnifier2.ani");
        // setANICursorWithGroupElement([".md-zoom",".medium-zoom-image"], "/ani/PostIMGMagnifier.ani");
        // setANICursorWithGroupElement(
        //   [".medium-zoom-overlay", ".medium-zoom-image--opened"],
        //   "/ani/PostIMGMagnifier2.ani"
        // );
        (_a = document
            .querySelector("html")) === null || _a === void 0 ? void 0 : _a.setAttribute("data-not-show-universe", String(store.isShowUniverse));
        // 使用 BroadCastChannel 在多个标签页间同步设置数据，避免出现当调节明暗色后进行切换标签页等行为时把自己眼睛闪瞎的情况
        // 生成纯随机6位字符串作为UUID，避免自己处理自己标签页的消息
        window.tabId = Array.from({ length: 6 }, function () { return "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(Math.random() * 36)]; }).join("");
        var channel = new BroadcastChannel("blog_console");
        channel.onmessage = function (event) {
            var data = event.data;
            console.log(data.sender, window.tabId);
            if (data.sender === window.tabId)
                return; // 不处理自己的消息
            console.log("接收到 BroadcastChannel 消息", event);
            if (data.type === "theme") {
                // 明亮色主题
                if (typeof data.msg !== "boolean") {
                    console.log(data.msg, typeof data.msg);
                    throw "BoradCastChannelMsg type err";
                }
                if (store.isDarkTheme !== data.msg) {
                    store.switchDarkTheme(true);
                }
            }
        };
        window.broadcastChannel = channel;
        // 小加载阻塞提示跳转
        onBeforeRouteLeave(function (to, from, next) {
            if (store.smallLoadConnection !== 0) {
                var leave = window.confirm(leaveTipWords);
                if (!leave)
                    return next(false);
            }
            next();
        });
        window.addEventListener("beforeunload", function (event) {
            if (store.smallLoadConnection !== 0) {
                event.preventDefault();
                event.returnValue = leaveTipWords;
            }
        });
        onMounted(function () {
            if (window.localStorage.getItem("theme-color")) {
                document.documentElement.style.setProperty("--theme-color", window.localStorage.getItem("theme-color"));
            }
            var observer = new MutationObserver(updateRefs);
            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ["style"],
                childList: false,
                subtree: false,
            });
            // 初始化暗色主题情况
            // 使用切换时必须放在 onMounted 中，否则 naiveUI 颜色主题不会发生改变
            if (store.isAutoSwitchDarkTheme) {
                if (currentDatetime.getHours() >= startDarkThemeTime ||
                    currentDatetime.getHours() < endDarkThemeTime // 晚上11点到早上7点
                ) {
                    store.switchDarkTheme();
                }
            }
            else if (window.localStorage.getItem("console-theme-mode") === "dark") {
                store.switchDarkTheme();
            }
        });
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            var _component_n_dialog_provider = _resolveComponent("n-dialog-provider");
            var _component_n_message_provider = _resolveComponent("n-message-provider");
            var _component_n_notification_provider = _resolveComponent("n-notification-provider");
            return (_openBlock(), _createBlock(_unref(NConfigProvider), {
                theme: naiveUITheme.value,
                "theme-overrides": themeOverrides.value
            }, {
                default: _withCtx(function () { return [
                    _createVNode(_component_n_notification_provider, { placement: "bottom-right" }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_n_message_provider, null, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_n_dialog_provider, null, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_router_view)
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    })
                ]; }),
                _: 1
            }, 8, ["theme", "theme-overrides"]));
        };
    }
});
